export interface ITrainingReport {
  id: string
  userId: string
  lessonId: string
  startDate: Date
  endDate: Date
  completeStatus: CompleteStatus
  parameters: Array<ITrainingReportParameter>
}

export interface ITrainingReportParameter {
  id: string
  name: string
  value: string
}

export enum CompleteStatus {
  Completed,
  Quit,
}
